import type { ReactElement } from 'react';
import BaseLibraryIconSvg from '../BaseLibraryIconSvg';
import type { IconSvgProps } from '../Icon';

export default function Email(props: IconSvgProps): ReactElement {
  return (
    <BaseLibraryIconSvg {...props}>
      <path
        d='M4.77642 19.7856H19.4451C21.0637 19.7856 22 18.8581 22 17.0413V6.95873C22 5.14193 21.0557 4.21448 19.2236 4.21448H4.5513C2.92828 4.21448 2 5.13472 2 6.95873V17.0413C2 18.8653 2.93632 19.7856 4.77642 19.7856ZM4.7354 18.5548C3.76275 18.5548 3.23884 18.0389 3.23884 17.0341V6.95792C3.23884 5.96114 3.76275 5.44525 4.7354 5.44525H19.2566C20.2148 5.44525 20.7612 5.96115 20.7612 6.96596V17.0421C20.7612 18.0389 20.2148 18.5548 19.2566 18.5548H4.7354ZM12.0257 14.3445C12.6293 14.3445 13.2305 14.1053 13.8478 13.4953L21.3135 6.17858L20.461 5.32605L13.1355 12.5491C12.7429 12.9417 12.3761 13.1057 12.0257 13.1057C11.6672 13.1057 11.2968 12.93 10.9078 12.5491L3.55018 5.2939L2.70571 6.14641L10.1956 13.4953C10.8129 14.1053 11.4176 14.3445 12.0257 14.3445ZM20.3686 18.6527L21.2059 17.801L15.2021 11.9063L14.3612 12.7436L20.3686 18.6527ZM2.81943 17.811L3.66113 18.6743L9.69023 12.7436L8.8413 11.9063L2.81943 17.811Z'
        fill='currentColor'
      />
    </BaseLibraryIconSvg>
  );
}
